import {
  DEFAULT_DISCLAIMER_POSITION,
  DISCLAIMER_TEXT,
  type DISCLAIMER_POSITIONS,
} from "./constants";

export type DisclaimerPosition = (typeof DISCLAIMER_POSITIONS)[number];

/**
 * The disclosures a user selected at export/launch time. Applied transiently to
 * the exported asset — never persisted into the stored ad markup, so a later
 * export with different settings is free to differ.
 */
export interface DisclaimerSpec {
  /** Render the visible "Contains AI-generated content" overlay. */
  visible: boolean;
  /** Embed the machine-readable IPTC/XMP "AI generated" tag in the file. */
  machineReadable: boolean;
  /** Overlay copy. Defaults to DISCLAIMER_TEXT. */
  text: string;
  position: DisclaimerPosition;
}

/** Default selection when a disclosure modal opens (v1: both on). */
export const DEFAULT_DISCLAIMER_SPEC: DisclaimerSpec = {
  visible: true,
  machineReadable: true,
  text: DISCLAIMER_TEXT,
  position: DEFAULT_DISCLAIMER_POSITION,
};

/** No-op selection used when the disclosure feature is disabled (flag off). */
export const DISABLED_DISCLAIMER_SPEC: DisclaimerSpec = {
  visible: false,
  machineReadable: false,
  text: DISCLAIMER_TEXT,
  position: DEFAULT_DISCLAIMER_POSITION,
};
